module.exports = __webpack_public_path__ + "img/Logo.6a024e7b.svg";